(function() {
    'use strict';
    Odigeo.UIElements.enhanceCheckboxRadio = function(checkBoxInput) {
        var $checkBoxInput = $(checkBoxInput);
        var title = $checkBoxInput.attr('title');
        var description = $checkBoxInput.data('description');
        var isSwitch = ($checkBoxInput.attr('data-role') === 'switch');
        var $container = $('<div></div>');
        var $wrapper = $container.clone();
        var $innerWrapper = $wrapper.clone();
        var $titleSpan = $('<span></span>');
        var $descriptionSpan = $titleSpan.clone();
        var onChangeValue;

        if (!checkBoxInput || !($checkBoxInput instanceof $)) {
            return;
        }

        // Prevent further enhancements
        if ($checkBoxInput.attr('data-skip-enhance') === 'true') {
            return $checkBoxInput;
        }

        if (isSwitch) {
            $checkBoxInput.replaceWith($container);
            $checkBoxInput.hide().attr({'data-skip-enhance': true});
            $container.addClass('od-ui-toggleButton-container toggle_container').append(
                $wrapper.addClass('od-ui-toggleButton-wrapper')
                    .append($innerWrapper.addClass('od-ui-toggleButton' + ($checkBoxInput.is(':checked') ? ' active' : ''))
                        .append($titleSpan.clone().addClass('od-ui-toggleButton-thumb')))
                    .append($checkBoxInput)
            ).append($titleSpan.addClass('od-ui-toggleButton-label').text(title));
            if (description) {
                $titleSpan.append($descriptionSpan.addClass('od-ui-toggleButton-description').text(description));
            }
            onChangeValue = function(event, value) {
                if (event.type !== 'setDefault') {
                    if (!Odigeo._.isUndefined(value)) {
                        $innerWrapper.toggleClass('active', value);
                    } else {
                        $innerWrapper.toggleClass('active');
                    }
                }
                $container.trigger('change', [$innerWrapper.hasClass('active')]);

                if ($innerWrapper.hasClass('active')) {
                    $checkBoxInput.prop('checked', true);
                } else {
                    $checkBoxInput.removeAttr('checked');
                }
            };
            $container.on(Odigeo.Events.tap + ' ' + Odigeo.Events.swipe + ' setValue setDefault', onChangeValue);
        } else {
            // for different data-role(s)
            $container = $checkBoxInput.on('setValue setDefault', function(evt, value) {
                if (evt) {
                    evt.stopPropagation();
                    evt.preventDefault();
                }
                $checkBoxInput.attr('checked', value || value === 'checked').trigger('change');
            });
        }
        $container.on('disable', function() {
            $checkBoxInput.attr('disabled', 'disabled');
        }).on('enable', function() {
            $checkBoxInput.removeAttr('disabled');
        });
        return $container;
    };
}());
